import { createComponent } from '@helpers/admin';
import FaqAccordionSectionComponent from '@template/blocks/FaqAccordionSection/component';

export const FaqAccordion = createComponent({
  label: 'Accordion',
  component: FaqAccordionSectionComponent,
  fields: {
    header: {
      label: 'Header',
      type: 'object',
      objectFields: {
        title: {
          label: 'Title',
          type: 'textarea',
        },
        subtitle: {
          label: 'Subtitle',
          type: 'textarea',
        },
      },
    },
    subtitle: {
      label: 'Accordion Title',
      type: 'textarea',
    },
    accordionItems: {
      label: 'Items',
      type: 'array',
      arrayFields: {
        title: {
          label: 'Title',
          type: 'textarea',
        },
        content: {
          label: 'Content',
          type: 'textarea',
        },
      },
    },
  },
});
